import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { ApiService } from '../../../api.service';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder } from '@angular/forms';

@Component({
	selector: 'app-question-create',
	templateUrl: './question-create.component.html',
	styleUrl: './question-create.component.css'
})
export class QuestionCreateComponent implements OnInit {
	breadcrumbList = [
		{
			path: this.apiService.getHomeURL(),
			name: "Home"
		},
		{
			path: "/app/question-list",
			name: "Question List"
		}
	];
	uId: any = null;
	showForm = false;
	pagetitle = "Create Question";

	constructor(private toastr: ToastrService, private apiService: ApiService, private formBuilder: FormBuilder, private router: Router, private activeRoute: ActivatedRoute) { }

	ngOnInit(): void {
		this.activeRoute.params.subscribe(routeParams => {
			this.uId = routeParams["Id"] == undefined ? null : routeParams["Id"];
			if (this.uId) {
				this.pagetitle = "Edit Question";
				this.breadcrumbList.push({ path: "/app/createQuestionbank/" + this.uId, name: "Edit Question" });
			} else {
				this.breadcrumbList.push({ path: "/app/createQuestionbank", name: "Create Question" });
			}
			this.showForm = true;
		})
	}

	onSave(Id: any) {
		this.router.navigate(['/app/question-list']);
	}

	onCleared() {
		this.router.navigate(['/app/question-list']);
	}
}
